<template>
    <section id="sec2">

    <div :class="{'sobre': cor == false, 'sobredark': cor == true}">
        <div class="historia">
            <h1 v-if="traduzir == true">Sobre</h1>
            <h1 v-else>About</h1>

            <p v-if="traduzir == true">Somos uma empresa que oferece soluções digitais para ajudar nossos clientes a aumentar o faturamento e expandir seus negócios na internet.
                <br></br><br></br>Desenvolvemos aplicativos móveis, sites e jogos digitais que funcionam como ferramentas de marketing, auxiliando na captação de novos clientes e trazendo modernidade, inovação tecnológica e praticidade na venda de produtos e serviços.
                <br></br><br></br>Nossa empresa foi fundada em agosto de 2025 e está localizada em São Paulo - SP, mas atendemos clientes de todo o Brasil por meio de serviços digitais.
            </p>
            <p v-else>We are a company that provides digital solutions to help our clients increase revenue and expand their businesses online.
                <br></br><br></br>We develop mobile applications, websites, and digital games that work as marketing tools, helping attract new customers while bringing innovation, technological advancement, and convenience to the sale of products and services.
                <br></br><br></br>Our company was founded in August 2025 and is located in São Paulo, Brazil, but we serve clients nationwide through our digital services.</p>
        </div>        

        <div class="imagem">
            <img src="@/assets/imagens/sobre.png" alt="sobre">
        </div>

    </div>

    </section>
</template>

<script>
    export default { 
    name: 'Sobre',

    props: {
        cor: true,
        traduzir: true,
    },

}

</script>

<style src="./sobre.scss" lang="scss" scoped></style>